/**
 * Textos e links Stripe (admin de planos).
 */

export const STRIPE_PRODUCTS_URL = 'https://dashboard.stripe.com/products';

export const STRIPE_PLAN_EXPLAINER =
  'No Stripe, a assinatura usa um Price recorrente ligado a um Product. ' +
  'Copie o ID do Price (começa com price_) ou defina um lookup key no Price.';

export const STRIPE_PRICE_TEST_HINT =
  'Com o Stripe em modo teste, copie o price_… do preço de teste. ' +
  'Produção usa o campo “ID do Price” acima.';
